__turbopack_context__.v({
  "after": "button-module__2NABzW__after",
  "primary": "button-module__2NABzW__primary",
});
